
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getLoginUrl } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component
export default class SystemConfigUserAdd extends Vue {
  private modalShow = false;
  private FormData: objAny = {};
  private modalTitle = i18n.t("oper.loginInfo");
  private type = "query";
  private formItem: objAny = {};
  private itemData: objAny = {};

  public open(item: objAny, type: string) {
    if (type == "new") {
      this.formItem = item;
      this.itemData = {};
    } else {
      this.itemData = item;
      this.formItem = {};
      this.formItem.oprPkId = item.oprPkId;
      this.getLoginUrl();
    }
    this.type = type;
    this.modalShow = true;
  }
  async getLoginUrl(): Promise<void> {
    const ret = await getLoginUrl({ oprPkId: this.formItem.oprPkId });

    if (ret.status === this.$config.apiStatus) {
      this.formItem = ret.data[0];
    }
  }
  public copy(): void {
    const name: string = this.formItem.loginName
      ? this.formItem.loginName
      : this.itemData.userName;
    let text: string =
      i18n.t("oper.loginUrl") +
      ": " +
      this.formItem.loginUrl +
      "\n" +
      i18n.t("oper.loginName") +
      ": " +
      name;
    if (this.type == "new") {
      text +=
        "\n" + i18n.t("oper.loginPasswd") + ": " + this.formItem.loginPasswd;
    }
    console.log(text);
    this.$common.copyText(text);
  }
  public closeModal(): void {
    this.modalShow = false;
  }

  public resetPassword() {
    const name: string = this.formItem.loginName
      ? this.formItem.loginName
      : this.itemData.userName;
    this.closeModal();
    this.$router.push("/homepage/systemconfig/user?globalSearch=" + name);
  }
}
